import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const SupportList = Loadable(
  lazy(() =>
    import("./supportList").then(({ SupportList }) => ({
      default: SupportList,
    })),
  ),
);

const ManageSupport = Loadable(
  lazy(() =>
    import("./manageSupport").then(({ ManageSupport }) => ({
      default: ManageSupport,
    })),
  ),
);

export const supportRoutes = [
  {
    path: "/enr-support",
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.ENR_SUPPORT]}
      >
        <SupportList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/support/manage",
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.ENR_SUPPORT]}
      >
        <ManageSupport />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/support/manage/:supportTicketId",
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.ENR_SUPPORT]}
      >
        <ManageSupport />
      </AuthorizedRoute>
    ),
  },
];
